import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import CacheErrorBoundary from './components/CacheErrorBoundary';
// These page stylesheets were global before route code splitting (Sep 2026)
// and contain selectors other pages may rely on. Keep them global, in the same
// order as before (ahead of scrollbar.css / index.css).
import './pages/LicenseeServices.css';
import './pages/Dashboard.css';
import './pages/InvestmentSimulator.css';
import './pages/LatestProfitCSV.css';
import './scrollbar.css'; // Ensure the correct path
import './index.css';

ReactDOM.render(
  <React.StrictMode>
    <CacheErrorBoundary>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </CacheErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root')
);
